<template>
  <div>
    <div class="full-page" v-show="singlePagePdf">
      <b-icon-x
        style="z-index: 1000; position: relative;"
        class="close-icon"
        @click="
          closePage('singlePagePdf');
          recommendation = '';
          showRec = false;
        "
      ></b-icon-x>
      <div class="container-fluid">
        <h3>Single Page PDF</h3>

        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="createPdf">Download PDF</b-button>
        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="createPNG">Download PNG</b-button>
        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="showSettings = !showSettings">PDF Settings</b-button>
        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="saveRec" v-show="showRec">Save Recommendation</b-button>

        <div id="svg-single-page" class="container">
          <svg class="pdf-page" id="svg-single" :viewBox="`0 0 ${700} ${989}`">
            <!-- svg logo -->
            <g transform="scale(.4)translate(50,50)">
              <path :d="svgLogo.logoPath1" style="fill:#2fade2"></path>
              <path :d="svgLogo.logoPath2" style="fill:#2c2840"></path>
            </g>

            <!-- header info -->
            <text style="font: bold 8px sans-serif;" :x="col1" :y="rows(1)">Sample Numbers:</text>

            <g v-if="currentInfo.sampleNumberYoung">
              <text style="font: 7px sans-serif;" :x="col2" :y="rows(1)">{{ currentInfo.sampleNumberYoung }}</text>
              <text style="font: 5px sans-serif;" :x="col2 - 6" :y="rows(1) - 3">1</text>
            </g>

            <g v-if="currentInfo.sampleNumberOld">
              <text style="font: 7px sans-serif;" :x="col2" :y="rows(2) - 1">{{ currentInfo.sampleNumberOld }}</text>
              <text style="font: 5px sans-serif;" :x="col2 - 6" :y="rows(2) - 4">2</text>
            </g>

            <g v-if="currentInfo.sampleNumberMiddle">
              <text style="font: 7px sans-serif;" :x="col2 + 70" :y="rows(2) - 1">{{ currentInfo.sampleNumberMiddle }}</text>
              <text style="font: 5px sans-serif;" :x="col2 + 64" :y="rows(2) - 4">3</text>
            </g>

            <text style="font: bold 8px sans-serif;" :x="col1" :y="rows(3)">Name:</text>
            <text style="font: 8px sans-serif;" :x="col2" :y="rows(3)">{{ currentInfo.businessName }}</text>

            <text style="font: bold 8px sans-serif;" :x="col1" :y="rows(4)">Address:</text>
            <text style="font: 8px sans-serif;" :x="col2" :y="rows(4)">{{ currentInfo.street }}</text>
            <text style="font: 8px sans-serif;" :x="col1" :y="rows(5)">
              {{ `${currentInfo.city || ""} ${currentInfo.state || ""} ${currentInfo.postalCode || ""}` }}
            </text>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(7)">Remarks:</text>
            <text style="font: 8px sans-serif;">
              <tspan v-for="(row, i) of SVGLineWrap(currentInfo.comments, 75, 6)" :key="row" :x="col4 - 40" :y="rows(7) + i * 8">
                {{ row }}
              </tspan>
            </text>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(1)">Sample Date:</text>
            <text style="font: 8px sans-serif;" :x="col4" :y="rows(1)">{{ currentInfo.sampleDate }}</text>

            <text v-if="showMoon" style="font: bold 8px sans-serif;" :x="col3" :y="rows(0)">Moon Phase:</text>
            <text v-if="showMoon" style="font: 8px sans-serif;" :x="col4" :y="rows(0)">{{ moonIcon.phase }}</text>
            <g v-if="showMoon" :transform="`scale(.18)translate(2725,300)`" v-html="moonIcon.icon"></g>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(2)">Location/plot:</text>
            <text style="font: 8px sans-serif;" :x="col4" :y="rows(2)">{{ currentInfo.locationName }}</text>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(3)">Cultivation:</text>
            <text style="font: 8px sans-serif;" :x="col4" :y="rows(3)">{{ currentInfo.plotName }}</text>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(4)">Crop:</text>
            <text style="font: 8px sans-serif;" :x="col4" :y="rows(4)">{{ currentInfo.cropName }}</text>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(5)">Plant Part:</text>
            <g v-if="currentInfo.sampleNumberYoung">
              <text style="font: 8px sans-serif;" :x="col4" :y="rows(5)">Leaf (young)</text>
              <text style="font: 5px sans-serif;" :x="col4 - 6" :y="rows(5) - 3">1</text>
            </g>

            <g v-if="currentInfo.sampleNumberOld">
              <text style="font: 8px sans-serif;" :x="col4 + 70" :y="rows(5)">Leaf (old)</text>
              <text style="font: 5px sans-serif;" :x="col4 + 64" :y="rows(5) - 3">2</text>
            </g>

            <g v-if="currentInfo.sampleNumberMiddle">
              <text style="font: 8px sans-serif;" :x="col4 + 130" :y="rows(5)">Leaf (middle)</text>
              <text style="font: 5px sans-serif;" :x="col4 + 124" :y="rows(5) - 3">3</text>
            </g>

            <text style="font: bold 8px sans-serif;" :x="col3" :y="rows(6)">Variety:</text>
            <text style="font: 8px sans-serif;" :x="col4" :y="rows(6)">{{ currentInfo.varietyName }}</text>

            <!-- legend -->
            <SvgLegend :x="18" :y="160" />

            <!-- header -->
            <rect x="18" y="200" width="660" height="14" fill="#0E7FAD" />
            <text style="font: bold 8px sans-serif;" fill="white" x="20" y="210">Element</text>
            <text style="font: bold 7px sans-serif;" fill="white" :x="innerCol1" y="210" text-anchor="middle">Current Value</text>
            <text style="font: bold 7px sans-serif;" fill="white" :x="innerCol2" y="210" text-anchor="middle">Good</text>
            <text style="font: bold 7px sans-serif;" fill="white" v-if="showRec" text-anchor="middle" x="230" y="210">Priority</text>

            <!-- elements -->
            <g v-for="(elmt, i) of activeElements" :key="elmt.key" :transform="`translate(0,${graphRows(i)})`">
              <text style="font: bold 8px sans-serif;" x="20" y="25">{{ elmt.label }}</text>

              <rect :x="ranges(elmt.key).highl" y="15.5" :width="ranges(elmt.key).highh" height="29" fill="#e6f1fd" />
              <rect :x="ranges(elmt.key).okl" y="15.5" :width="ranges(elmt.key).okh" height="29" fill="#c5e1ff" />

              <g v-for="(val, i) of elementValues(elmt.key)" :key="val.id">
                <rect v-if="colorVals" :x="innerCol1 - 15" :y="18.5 + i * rectHeight" width="28" height="11" :fill="val.realColor" />

                <text style="font: 8px sans-serif;" text-anchor="middle" :x="innerCol1" :y="26.5 + i * rectHeight">{{ val.value }}</text>
                <text style="font: 7px sans-serif;" text-anchor="middle" x="95" :y="26.5 + i * rectHeight">{{ val.units }}</text>
                <text style="font: 5px sans-serif;" x="270" :y="26 + i * rectHeight">
                  {{ val.plantPart === "young" ? "1" : val.plantPart === "old" ? "2" : "3" }}
                </text>

                <!-- recommendations column -->
                <text
                  style="font: 7px sans-serif; cursor: pointer;"
                  v-if="showRec"
                  @click="editRec(elmt.key)"
                  text-anchor="middle"
                  x="230"
                  :y="26.5 + i * rectHeight"
                >
                  {{ getRec(elmt.key) }}
                </text>

                <rect :x="val.start" :y="22.5 + i * barHeight" :width="val.y" :height="barHeight" :fill="val.color" />
              </g>

              <text style="font: 7px sans-serif;" text-anchor="middle" :x="innerCol2" y="26">{{ elementRange(elmt.key) }}</text>

              <line x1="278" x2="278" y1="15" y2="45" style="stroke:black;stroke-width:.75" />
              <line x1="678" x2="678" y1="15" y2="45" style="stroke:black;stroke-width:.75" />

              <!-- divider lines -->
              <line x1="18" x2="678" y1="45" y2="45" style="stroke:#888;stroke-width:.5" />
              <line x1="18" x2="678" y1="47" y2="47" style="stroke:#888;stroke-width:.5" />
            </g>

            <text
              v-for="ann of annotations"
              :key="ann.id"
              class="draggable"
              :style="`font: ${ann.fontSize}px sans-serif;`"
              :fill="ann.color"
              x="180"
              y="180"
            >
              {{ ann.text }}
            </text>

            <!-- disclaimer  -->
            <PdfDisclaimer :x="col1" :y="962" />
          </svg>
        </div>

        <div style="padding: 4em;"></div>

        <div class="pdf-sidebar-outer" v-show="showSettings">
          <div class="pdf-sidebar">
            <div class="pdf-inner">
              <b-icon-chevron-right class="close-settings-icon" @click="showSettings = false"></b-icon-chevron-right>

              <h3>PDF Settings</h3>
              <b-form style="text-align: left;">
                <b-form-group label="Select Type of PDF:">
                  <b-form-radio-group stacked v-model="pdfType" :options="options"></b-form-radio-group>
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox v-model="colorVals" switch>Color Values</b-form-checkbox>
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox v-model="showRec" switch>Show AI Recommendation</b-form-checkbox>
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox v-model="showMoon" switch>Show Moonphase</b-form-checkbox>
                </b-form-group>

                <PDFAnnotations name="single" />

                <div class="mt-4"></div>

                <b-button v-show="orderHasChanged" size="sm" @click="resetOrder"> Reset </b-button>

                <draggable v-model="elementList" @start="drag = true" @end="drag = false" v-bind="dragOptions" group="elements">
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div class="list-item" v-for="elmt of elementList" :key="elmt.id">
                      <b-form-checkbox v-model="elmt.active">{{ elmt.label }}</b-form-checkbox>
                    </div>
                  </transition-group>
                </draggable>
              </b-form>
            </div>
          </div>
        </div>

        <b-modal id="edit-rec" title="Edit Recommended Value" hide-footer centered>
          <h4 style="text-align: left; margin-bottom: 1.5em;">{{ currentRecElmt }}</h4>

          <b-form style="text-align: left;">
            <b-form-group label="Select Value:">
              <b-select @change="changeRec" :options="['None', 'Low', 'Medium', 'High']"></b-select>
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
    <Alert />
  </div>
</template>

<script>
import { scaleLinear } from "d3";
import draggable from "vuedraggable";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { logoPath1, logoPath2 } from "../assets/images/CHLlogo";
import Alert from "../components/Alert";
import SvgLegend from "../components/SvgLegend";
import { pdf, recommendation } from "../modules/api";
import { selectColor } from "../modules/colors";
import { downloadSvg, dynamicSortNumber, makeDraggableSvg, randomId } from "../modules/utils";
import PdfDisclaimer from "./PdfDisclaimer.vue";

import { EventBus } from "../modules/eventBus";
import { lunarPhaseAndIcon } from "../modules/moonphase";
import PDFAnnotations from "./PDFAnnotations.vue";

export default {
  name: "single-page-pdf",
  props: {
    currentRecord: String,
  },
  data() {
    return {
      col1: 18,
      col2: 120,
      col3: 310,
      col4: 420,
      elements: [
        { id: 1, active: true, key: "sugar", label: "Total Sugars" },
        { id: 2, active: true, key: "pH", label: "pH" },
        { id: 3, active: true, key: "EC", label: "EC" },
        { id: 4, active: true, key: "potassium", label: "Potassium" },
        { id: 5, active: true, key: "calcium", label: "Calcium" },
        { id: 6, active: true, key: "magnesium", label: "Magnesium" },
        { id: 7, active: true, key: "sodium", label: "Sodium" },
        { id: 8, active: true, key: "ammonium", label: "Ammonium" },
        { id: 9, active: true, key: "NO3_nitrate", label: "Nitrate" },
        { id: 10, active: true, key: "nitrogen_in_nitrate", label: "N in Nitrate" },
        { id: 11, active: true, key: "nitrogen", label: "Total Nitrogen" },
        { id: 12, active: true, key: "chloride", label: "Chloride" },
        { id: 13, active: true, key: "sulfur", label: "Sulfur" },
        { id: 14, active: true, key: "phosphorous", label: "Phosphorus" },
        { id: 15, active: true, key: "silica", label: "Silica" },
        { id: 16, active: true, key: "iron", label: "Iron" },
        { id: 17, active: true, key: "manganese", label: "Manganese" },
        { id: 18, active: true, key: "zinc", label: "Zinc" },
        { id: 19, active: true, key: "boron", label: "Boron" },
        { id: 20, active: true, key: "copper", label: "Copper" },
        { id: 21, active: true, key: "molybdenum", label: "Molybdenum" },
        { id: 23, active: true, key: "cobalt", label: "Cobalt" },
        { id: 22, active: true, key: "aluminium", label: "Aluminium" },
      ],
      showSettings: false,
      drag: false,
      orderHasChanged: false,
      pdfType: "regular simple",
      options: [
        { text: "AEA Regular Bars", value: "regular simple" },
        { text: "AEA Regular Bars Color", value: "regular muted" },
        { text: "AEA Centerline Bars", value: "center simple" },
        { text: "AEA Centerline Bars Color", value: "center muted" },
      ],
      colorVals: true,
      showRec: false,
      showMoon: false,
      recommendation: "",
      recChanged: false,
      currentRecElmt: "sugar",
      annotations: [],
    };
  },
  methods: {
    async createRec() {
      let res = await recommendation.create({ sampleNumbers: [this.tests.data[0].sampleNumber] });

      if (res.data.success) {
        let rec = res.data.records[0];
        if (rec.success === false) {
          this.showRec = false;
          this.notify({
            variant: "warn",
            message: rec.message,
          });
        } else {
          this.recommendation = rec;
        }
      } else {
        this.showRec = false;
        this.notify({
          variant: "warn",
          message: res.data.message,
        });
      }
    },

    getRec(element) {
      if (!this.recommendation.rec) {
        return "";
      }
      let rec = this.recommendation.rec.find(x => x.element === element);

      if (rec) {
        return rec.value;
      }
      return "";
    },

    editRec(element) {
      this.currentRecElmt = element;
      this.$bvModal.show("edit-rec");
    },

    changeRec(val) {
      let rec = this.recommendation.rec.find(x => x.element === this.currentRecElmt);
      if (!rec) {
        return;
      }

      this.recChanged = true;

      rec.value = val;
      this.$bvModal.hide("edit-rec");
    },

    async saveRec() {
      if (this.recChanged) {
        let res = await recommendation.save(this.recommendation);
        if (res.data.success) {
          this.recChanged = false;
        }
      }
    },

    SVGLineWrap(text, maxLength, maxArrayLength = false) {
      // break up text into an array based on a maxlength of charachters, essentially linewrap for SVG
      let stringArr = [];

      let len = 0;
      let str = "";
      if (!text) {
        return stringArr;
      }
      while (len <= text.length) {
        if (text.length - len <= maxLength) {
          stringArr.push(text.slice(len, text.length));
          break;
        }
        str = text.slice(len, len + maxLength);
        let index = str.lastIndexOf(" ");
        if (index != -1) {
          index++;
          stringArr.push(text.slice(len, len + index));
          len += index;
        } else {
          stringArr.push(text.slice(len, len + maxLength));
          len += maxLength;
        }
      }
      if (typeof maxArrayLength === "number") {
        return stringArr.slice(0, maxArrayLength);
      }
      return stringArr;
    },

    async createPdf() {
      let svg = document.getElementById("svg-single-page").innerHTML;

      let res = await pdf.createLinePdf({ svgs: [svg] });

      const blob = new Blob([res.data], { type: "application/pdf" });

      // process to auto download it
      const fileURL = URL.createObjectURL(blob);
      const link = document.createElement("a");
      document.body.append(link);
      link.href = fileURL;
      link.download = `${this.currentInfo.businessName}-${this.currentInfo.locationName}-${
        this.currentInfo.plotName
      }-${new Date().toISOString().slice(0, 10)}.pdf`;
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(link);
      }, 100);

      if (this.recChanged) {
        let res = await recommendation.save(this.recommendation);
        if (res.data.success) {
          this.recChanged = false;
        }
      }
    },

    async createPNG() {
      this.showMoon = false;
      await this.$nextTick();
      let fileName = `${this.currentInfo.businessName}-${this.currentInfo.locationName}-${this.currentInfo.plotName}-${new Date()
        .toISOString()
        .slice(0, 10)}.png`;
      let svg = document.getElementById("svg-single-page");
      downloadSvg(svg.firstChild, fileName);
    },

    ranges(element) {
      let { y, data, range } = this.scaleAndData(element);
      let margin = 278;

      if (this.pdfBarType === "regular") {
        return {
          okl: y(range["Ok Low"]) + margin,
          okh: y(range["Ok High"]) - y(range["Ok Low"]),
          highl: y(range["Very Low"]) + margin,
          highh: y(range["Very High"]) - y(range["Very Low"]),
          perfect: y(range["Perfect"]) + margin,
        };
      } else {
        return {
          okl: 200 + margin - y(range.Perfect) + y(range["Ok Low"]),
          okh: y(range["Ok High"] - range["Ok Low"]),
          highl: 200 + margin - y(range.Perfect) + y(range["Very Low"]),
          highh: y(range["Very High"] - range["Very Low"]),
          perfect: margin + 200,
        };
      }
    },

    elementValues(element) {
      let { y, data, range } = this.scaleAndData(element);
      const perfect = range.Perfect;
      let colorBook = this.pdfType.split(" ")[1];
      const margin = 278;

      if (this.pdfBarType === "regular") {
        return data.map(x => ({
          ...x,
          y: y(x.value),
          start: y(0) + margin,
          color: selectColor(x.value, range, x.plantPart, colorBook),
          realColor: selectColor(x.value, range, "young", "muted"),
        }));
      } else {
        return data.map(x => {
          let innerY, start;
          if (x.value > perfect) {
            innerY = y(x.value) - y(perfect);
            start = 200.5 + margin;
          } else {
            innerY = y(perfect) - y(x.value);
            start = 199.5 + margin - y(perfect) + y(x.value);
          }

          return {
            ...x,
            y: innerY,
            start,
            color: selectColor(x.value, range, x.plantPart, colorBook),
            realColor: selectColor(x.value, range, "young", "muted"),
          };
        });
      }
    },

    elementRange(element) {
      let range = this.currentSeriesRange(element);
      if (!range["Ok Low"] || !range["Ok High"]) {
        return "";
      }
      return `${range["Ok Low"]} - ${range["Ok High"]}`;
    },

    scaleAndData(element) {
      const range = this.currentSeriesRange(element);

      let tests = [];
      for (let row of this.testsByPlantPart) {
        if (row.data) {
          let young = row.data.values.find(x => x.name === element);
          if (!young) {
            young = { value: 0 };
          }
          young.id = randomId();
          young.plantPart = row.plantPart;
          tests.push(young);
        }
      }

      const allVals = tests.map(x => x.value);

      let values = [];
      if (this.pdfBarType === "regular") {
        values = tests.map(x => parseFloat(x.value));

        if (range["Very Low"] && range["Very High"]) {
          values = values.concat([range["Very Low"], range["Very High"]], 0);
        } else {
          values.push(0);
        }
        const y = scaleLinear()
          .domain([Math.min(...values), Math.max(...values)])
          .range([0, 400]);
        return { y, range, data: tests };
      } else {
        values.push(range["Very High"] - range["Perfect"]);
        values.push(range["Perfect"] - range["Very Low"]);
        values.push(Math.max(...allVals) - range["Very High"] + values[0]);
        values.push(range["Very Low"] - Math.min(...allVals) + values[1]);
        // values.push(old.value - range["Very High"] + values[0]);
        // values.push(range["Very Low"] - old.value + values[1]);
        values.push(range["Perfect"]);
        values = values.map(x => parseFloat(x));

        let maxWidth = Math.max(...values);

        const y = scaleLinear()
          .domain([0, maxWidth])
          .range([0, 200]);
        return { y, range, data: tests };
      }
    },

    currentSeriesRange(element) {
      if (!this.tests.data[0]) {
        return {};
      }
      const crop = this.tests.data[0].cropName;
      const ranges = this.getRanges.find(x => x.cropName == crop);
      const elmtRange = {};
      if (ranges) {
        for (let name of ranges.names) {
          elmtRange[name] = ranges[name][element];
        }
      }
      return elmtRange;
    },

    resetOrder() {
      this.elements.sort(dynamicSortNumber("id"));
      this.orderHasChanged = false;
    },
    ...mapMutations(["closePage"]),
    ...mapActions(["notify"]),
  },
  computed: {
    testsByPlantPart() {
      const plantParts = ["young", "middle", "old"];

      return plantParts.map(plantPart => ({
        plantPart,
        data: this.tests.data.find(x => x.plantPart.includes(plantPart)) || null,
      }));
    },

    tests() {
      const externalId = this.currentRecord;
      let test = this.searchResults.find(x => x.externalId === externalId);

      if (!test) {
        return { data: [] };
      }

      let address = this.addresses.find(x => x.businessId === test.businessId);

      if (address && address.address.length > 1) {
        let billing = address.address.find(x => x.type === "billing");
        if (billing) {
          address.address[0] = billing;
        }
      }

      let mainTests = [test];
      if (test.setId) {
        mainTests = mainTests.concat(this.searchResults.filter(x => x.setId === test.setId && x.externalId !== test.externalId));
      }
      return { data: mainTests, address: address.address[0] };
    },

    currentInfo() {
      if (!this.tests.data || !this.tests.data[0]) {
        return {};
      }

      let sampleNumberYoung = this.tests.data.find(x => x.plantPart.includes("young"));
      let sampleNumberOld = this.tests.data.find(x => x.plantPart.includes("old"));
      let sampleNumberMiddle = this.tests.data.find(x => x.plantPart.includes("middle"));

      sampleNumberYoung = sampleNumberYoung?.sampleNumber;
      sampleNumberOld = sampleNumberOld?.sampleNumber;
      sampleNumberMiddle = sampleNumberMiddle?.sampleNumber;

      return {
        ...this.tests.address,
        ...this.tests.data[0],
        sampleDate: new Date(this.tests.data[0].sampleDate).toLocaleDateString(),
        sampleNumberOld,
        sampleNumberYoung,
        sampleNumberMiddle,
      };
    },

    rows() {
      return function(rowNum) {
        let start = 70;
        let rowPx = 12;
        return rowNum * rowPx + start;
      };
    },

    graphRows() {
      return function(rowNum, x) {
        let start = 199;
        let rowPx = 32;
        return rowNum * rowPx + start;
      };
    },

    svgLogo() {
      return { logoPath1, logoPath2 };
    },

    activeElements() {
      return this.elements.filter(x => x.active);
    },

    pdfBarType() {
      return this.pdfType.split(" ")[0];
    },
    moonIcon() {
      return lunarPhaseAndIcon(new Date(this.currentInfo.sampleDate));
    },

    elementList: {
      get() {
        return this.elements;
      },
      set(list) {
        this.orderHasChanged = true;
        this.elements = list;
      },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    innerCol1() {
      return this.showRec ? 125 : 150;
    },

    innerCol2() {
      return this.showRec ? 180 : 220;
    },

    isTripleRowSet() {
      return this.tests.data.length == 3;
    },

    barHeight() {
      return this.isTripleRowSet ? 6 : 7;
    },
    rectHeight() {
      return this.isTripleRowSet ? 8 : 12;
    },

    ...mapGetters({
      singlePagePdf: "singlePagePdf",
      addresses: "currentAddresses",
      searchResults: "currentSearchResults",
      getRanges: "getRanges",
    }),
  },
  mounted() {
    EventBus.$on("update-annotations", data => {
      if (data.name === "single") {
        this.annotations = data.annotations;
      }
    });
  },
  watch: {
    async singlePagePdf(val) {
      if (val === true) {
        await this.$nextTick();
        makeDraggableSvg(this.$el.querySelector("#svg-single"));
      }
    },
    showRec(val) {
      if (val === true && !this.recommendation) {
        this.createRec();
      }
    },
  },
  components: {
    draggable,
    SvgLegend,
    PdfDisclaimer,
    Alert,
    PDFAnnotations,
  },
};
</script>

<style lang="scss" scoped>
.draggable {
  cursor: grab;
}

.pdf-page {
  box-shadow: 0px 0px 5px #484848;
  margin-bottom: 5px;
}

.logo-scale {
  transform: scale(0.3);
}

.pdf-sidebar-outer {
  position: fixed;
  right: 0;
  top: 0;
  width: 20em;
  height: 100%;
}

.pdf-sidebar {
  position: relative;
  padding-top: 3.5em;
  background-color: rgb(253, 247, 239);
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 5px #484848;
}

.pdf-inner {
  position: relative;
  margin: 1em;
  padding-bottom: 4em;
}

.close-settings-icon {
  font-size: 1.8em;
  color: #7a7a7a;
  float: left;
  cursor: pointer;
  margin-top: -0.2em;
  margin-right: -1em;
}

.list-item {
  padding: 0.3em;
  margin: 0.4em;
  background-color: white;
  text-align: left;
  box-shadow: 0px 0px 2px #7a7a7a;
  border-radius: 5px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}
</style>
